interface IRecover {
    email: string,
    referrer_url: string,
    recaptcha: {
        token: string,
        action: string
    }
}

export const instanceOfIRecover = (object: any): object is IRecover => {
    return 'email' in object &&
        'referrer_url' in object &&
        'recaptcha' in object
}

export default IRecover